export const PREFECTURES = [
  { key: "25", value: "滋賀", text: "滋賀" },
  { key: "26", value: "京都", text: "京都" },
  { key: "27", value: "大阪", text: "大阪" },
  { key: "28", value: "兵庫", text: "兵庫" },
  { key: "29", value: "奈良", text: "奈良" },
];
